import { Upload as AntdUpload } from 'antd';
import type { RcFile } from 'antd/lib/upload';
import { FormattedMessage } from 'react-intl';

import { acceptPdfOrWarn, pdfDraggerProps } from './pdf-dragger';

const { Dragger } = AntdUpload;

type WaybillPdfDraggerProps = {
  /** Called once per dropped PDF; the promise settles when its upload does. */
  onFile: (file: File) => Promise<void>;
};

/** Regular dropzone: one PDF = one waybill import. */
export const WaybillPdfDragger = ({ onFile }: WaybillPdfDraggerProps) => {
  const beforeUpload = async (file: RcFile) => {
    if (acceptPdfOrWarn(file)) await onFile(file);
    // Returning LIST_IGNORE prevents Antd's own upload pipeline.
    return AntdUpload.LIST_IGNORE;
  };

  return (
    <Dragger {...pdfDraggerProps} beforeUpload={beforeUpload}>
      <p className="ant-upload-text">
        <FormattedMessage id="waybills.imports.dropzone.title" />
      </p>
      <p className="ant-upload-hint">
        <FormattedMessage id="waybills.imports.dropzone.hint" />
      </p>
    </Dragger>
  );
};
